"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActualQuantity = exports.getOriginalQuantity = void 0;
function getOriginalQuantity(taskInventory) {
    var quantityFactor = taskInventory.quantityFactor || 1;
    return taskInventory.original_quantity * quantityFactor;
}
exports.getOriginalQuantity = getOriginalQuantity;
function getActualQuantity(taskInventory) {
    var quantityFactor = taskInventory.quantityFactor || 1;
    return (quantityFactor * Math.max((taskInventory.original_quantity || 0) - (taskInventory.rejected_quantity || 0), 0));
}
exports.getActualQuantity = getActualQuantity;
//# sourceMappingURL=with_quantity.js.map